export const countMessagesReceivedByQuarterHourOfWeek = {
  analysisType: 'count',
  eventCollection: 'message.received',
  groupBy: 'time.quarter_hour_of_week',
  key: 'countMessagesReceivedByQuarterHourOfWeek',
}
